import React, { FC, useLayoutEffect, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useMetaMask } from '../context/MetaMaskContext';

import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { getListProjectRequested, createProjectRequested, resetNewProject } from '../redux/reducers/project.slice';

import Header from '../components/Header';
import Footer from '../components/Footer';
import ProjectItem from '../components/ProjectItem';
import ModalCreateProject from '../components/ModalCreateProject';

import toast from 'react-hot-toast';

type ProjectProps = {};

const Project: FC<ProjectProps> = (props) => {
  let history = useHistory();
  const dispatch = useAppDispatch();

  const [page, setPage] = useState<number>(1);
  const [numPages, setNumPages] = useState<null | number>(null);
  const [projectsWithPagination, setProjectsWithPagination] = useState<Project[]>([]);
  const { metaMask } = useMetaMask();
  const itemPerPage = 6;

  const projects = useAppSelector((state) => state.project.value);
  const justCreatedProject = useAppSelector((state) => state.project.newProject);
  const token = useAppSelector((state) => state.auth.token);

  const [isOpenModalCreateProject, setIsOpenModalCreateProject] = useState(false);

  useLayoutEffect(() => {
    if (!token) {
      return;
    }

    dispatch(getListProjectRequested());
  }, [token]);

  useEffect(() => {
    if (!justCreatedProject?.id) return;

    dispatch(resetNewProject());
    history.push(`/project/${justCreatedProject.id}`);

  }, [justCreatedProject]);

  useEffect(() => {
    // if (!projects.length) return;

    setNumPages(Math.ceil(projects.length / itemPerPage));
  }, [projects]);

  useEffect(() => {
    // if (!projects.length) return;

    // setNumPages(Math.ceil(projects.length / itemPerPage));
    // setProjectsWithPagination
    const idx = (page - 1) * itemPerPage;
    const pagination = projects.slice(idx, idx + itemPerPage);
    setProjectsWithPagination(pagination);
  }, [projects, page]);

  const openModalCreateProject = () => {
    if (!metaMask.account || !metaMask.chainId) {
      return toast('Connect your wallet to start');
    }
    setIsOpenModalCreateProject(true);
  };

  function nextPage() {
    if (!numPages) return;

    setPage((page) => {
      let newPage = page + 1;
      if (newPage > numPages) return page;
      return newPage;
    });
  }

  function prevPage() {
    if (!numPages) return;

    setPage((page) => {
      let newPage = page - 1;
      if (newPage <= 0) return page;

      return newPage;
    });
  }

  return (
    <>
      <Header />

      <div className="screen-container screen-container--project-page">
        <div className="img-background">
          <img src="./images/project_background_left.png" alt="" />
          <img src="./images/project_background.jpg" alt="" />
          <img src="./images/project_background_right.png" alt="" />
        </div>
        <div className="gradient-background">
          <div></div>
          <div></div>
        </div>
        <div className="project">
          <div className="project-container">
            <div className="project-header">
              <div className="project-header-title">
                <span>PROJECTS</span>
              </div>
              <span>Create new project</span>
              <button onClick={() => openModalCreateProject()}>
                <span>+</span>
              </button>
            </div>
            <div className="project-scroll">
              <div className="project-content">
                {projectsWithPagination.map((item, index) => (
                  <ProjectItem key={`${item?.id || index}`} project={item} />
                ))}
              </div>
            </div>

            <div className="project-pagination">
              <div className="project-pagination-container">
                {!!numPages && (
                  <>
                    <button onClick={prevPage}>{'<'}</button>
                    {Array.from({ length: numPages })?.map((_, index) => (
                      <button
                        className={`${page === index + 1 ? 'active' : ''}`}
                        key={index}
                        onClick={() => setPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    ))}
                    <button onClick={nextPage}>{'>'}</button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalCreateProject
        isOpen={isOpenModalCreateProject}
        toggle={() => setIsOpenModalCreateProject(!isOpenModalCreateProject)}
      />

      <Footer />
    </>
  );
};

export default Project;
